<template>
  <oms-filter-dropdown :title='title' :icon='icon' :isFiltering='isFiltering'>
    <slot />
    <label class='form-check' v-for='(value, status) in statuses' :key='status'>
      <input class='form-check-input' type='checkbox'
        :checked='modelValue && modelValue.include && modelValue.include.includes(status)' @input='toggleStatusSelected(status)' />
      <span class='form-check-label'>
        <i class='ri-checkbox-blank-circle-fill' :class='colorClass(status)' :style='colorStyle(value)'></i>
        {{ displayName(value) }}
      </span>
    </label>

    <div class='pt-2'>
      <button type='button' class='btn btn-sm btn-light' @click='selectAll'>
        {{ t('features.vue.shared.filters.select_all') }}
      </button>
      <button type='button' class='btn btn-sm btn-light' @click='selectNone'>
        {{ t('features.vue.shared.filters.select_none') }}
      </button>
    </div>
  </oms-filter-dropdown>
</template>

<script>
import OmsFilterDropdown from '../filter-dropdown.vue'

export default {
  inject: ['i18n'],

  props: {
    title: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: 'ri-git-branch-line'
    },
    color: {
      type: String
    },
    statuses: Object,
    modelValue: Object
  },

  computed: {
    isFiltering() {
      return this.modelValue && this.modelValue.include && this.modelValue.include.length > 0
    }
  },

  methods: {
    t(key, options) {
      return this.i18n ? this.i18n.t(key, options) : key
    },

    displayName(val) {
      return typeof val === 'string' ? val : val?.name
    },

    colorStyle(val) {
      if (val && typeof val === 'object' && val.color) {
        return { color: val.color }
      }
      return {}
    },

    colorClass(status) {
      if (this.color) {
        return `text-${this.color}`
      } else {
        return `text-${status.replace(/_/g, '-')}`
      }
    },

    toggleStatusSelected(modelValue) {
      const currentValues = (this.modelValue && this.modelValue.include) || []

      if (currentValues.includes(modelValue)) {
        this.$emit(
          'update:modelValue',
          { include: currentValues.filter((item) => item !== modelValue) }
        )
      } else {
        this.$emit('update:modelValue', { include: [...currentValues, modelValue] })
      }
    },

    selectAll() {
      this.$emit('update:modelValue', { include: Object.keys(this.statuses) })
    },

    selectNone() {
      this.$emit('update:modelValue', { include: [] })
    }
  },

  components: {
    OmsFilterDropdown
  }
}
</script>
